import { motion } from "framer-motion";
import { NETWORK_NODES } from "@/data/content";

// Abstract sovereign network — communities connected by trust, not extraction.
export default function LivingNetwork() {
  const center = { x: 50, y: 48 };

  return (
    <div
      data-testid="living-network"
      className="relative w-full aspect-[16/10] md:aspect-[16/8]"
    >
      <svg
        viewBox="0 0 100 70"
        className="w-full h-full overflow-visible"
        preserveAspectRatio="xMidYMid meet"
      >
        <defs>
          <radialGradient id="wk-glow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#D4A373" stopOpacity="0.9" />
            <stop offset="100%" stopColor="#D4A373" stopOpacity="0" />
          </radialGradient>
        </defs>

        {/* connection arcs to a symbolic centre */}
        {NETWORK_NODES.map((n, i) => {
          const mx = (n.x + center.x) / 2;
          const my = Math.min(n.y, center.y) - 8;
          return (
            <path
              key={`arc-${i}`}
              d={`M ${n.x} ${n.y} Q ${mx} ${my} ${center.x} ${center.y}`}
              fill="none"
              stroke="#D4A373"
              strokeOpacity="0.28"
              strokeWidth="0.25"
              strokeDasharray="1.5 2.5"
              style={{ animation: `wk-dash ${18 + i * 2}s linear infinite` }}
            />
          );
        })}

        {/* centre */}
        <circle cx={center.x} cy={center.y} r="9" fill="url(#wk-glow)" />
        <circle cx={center.x} cy={center.y} r="1.6" fill="#E6CCB2" />

        {/* nodes */}
        {NETWORK_NODES.map((n, i) => (
          <g key={`node-${i}`}>
            <circle
              cx={n.x}
              cy={n.y}
              r="3.2"
              fill="url(#wk-glow)"
              style={{ transformOrigin: `${n.x}px ${n.y}px` }}
            >
              <animate
                attributeName="opacity"
                values="0.3;0.7;0.3"
                dur={`${3 + (i % 4)}s`}
                repeatCount="indefinite"
              />
            </circle>
            <circle cx={n.x} cy={n.y} r="0.9" fill="#F4F1ED" />
          </g>
        ))}
      </svg>

      {/* labels */}
      {NETWORK_NODES.map((n, i) => (
        <motion.div
          key={`label-${i}`}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.15 + i * 0.08, duration: 0.7 }}
          className="absolute -translate-x-1/2 -translate-y-1/2 pointer-events-none"
          style={{ left: `${n.x}%`, top: `${(n.y / 70) * 100}%` }}
        >
          <span className="mt-6 block text-[10px] md:text-xs tracking-wide text-[#A8A5A1] whitespace-nowrap translate-y-4">
            {n.label}
          </span>
        </motion.div>
      ))}
    </div>
  );
}
